import { apiSlice } from "./apiSlice";
import { API_END_POINT } from "config";

const workFlowSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMyWork: builder.query({
            query: (id) => ({
                url: `${API_END_POINT}Workflow/mywork`,
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["My-WorkFlow"],
        }),

        updateMyWork: builder.mutation({
            query: (id) => ({
                url: `${API_END_POINT}Workflow/status`,
                method: 'PUT',
            }),
            providesTags: ["WorkFlow"],
        }),
        getMyTaskHistory: builder.query({
            query: ({ instanceId, type }) => ({
                url: `Workflow/history/${instanceId}/${type}`,
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["WorkFlowHistory"],
        }),
        getWorkflowDetail: builder.query({
            query: (id) => ({
                url: `Workflow/${id}`,
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["My-WorkFlow"],
        }),
        approveWorkflowTask: builder.mutation({
            query: ({ id, body }) => ({
                url: `workflow/${id}/approve`,
                method: 'POST',
                body
            }),
            invalidatesTags: ["My-WorkFlow", "WorkFlowHistory"],
        }),
        rejectWorkflowTask: builder.mutation({
            query: ({ id, body }) => ({
                url: `workflow/${id}/reject`,
                method: 'POST',
                body
            }),
            invalidatesTags: ["My-WorkFlow", "WorkFlowHistory"],
        }),
        triggerWorkflow: builder.mutation({
            query: ({ projectId, body }) => ({
                url: `Workflow/${projectId}/trigger`,
                method: 'POST',
                body
            }),
            // invalidateTags: ["My-WorkFlow"],
        }),
        getWorkflowInstances: builder.query({
            query: ({ projectId, entityType }) => ({
                url: `Workflow/workflowInstances/${projectId}/${entityType}`,
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["WorkflowInstances"],
        }),
    })
});

export default workFlowSlice;

export const { useGetMyWorkQuery, useUpdateMyWorkMutation,
    useGetMyTaskHistoryQuery, useGetWorkflowDetailQuery,
    useApproveWorkflowTaskMutation, useRejectWorkflowTaskMutation, useTriggerWorkflowMutation, useGetWorkflowInstancesQuery
} = workFlowSlice;
